import React, { useState } from 'react';

import EditSVG from '../assets/svg/edit';
import { SVGWrapper, FlexRow, ButtonWrapper } from './css';
import CancelSVG from '../assets/svg/cancel';
import SaveSVG from '../assets/svg/save';
import { changeService, saveServiceInOffering } from './saveSchemaToDB';

export default function ServiceLabel({
  serviceLabel,
  offeringId,
  serviceIndex,
  setSavingData,
  managedDetectionResponseData,
  setManagedDetectionResponseData
}) {
  const [label, setLabel] = useState(serviceLabel);
  const [editMode, setEditMode] = useState(!serviceLabel);

  const handleSave = async () => {
    const clonedAdminData = JSON.parse(JSON.stringify(managedDetectionResponseData));
    let serviceId =clonedAdminData.id;

    if (label) {
        try{
        setSavingData(true);
        if(serviceId)
        {
            await changeService(serviceId,{name:label,isSaved:true,ord:serviceIndex});
           clonedAdminData.name = label;
        }
        else
        {
            serviceId = await saveServiceInOffering({
                offeringId,
                ord:serviceIndex,
                name: label,
            });
           clonedAdminData.id = serviceId;
           clonedAdminData.name = label;
           clonedAdminData.offeringId = offeringId;
          
        }
        setManagedDetectionResponseData(clonedAdminData);

        
        setEditMode(false);
        }
        catch{
            console.log("An error occurred while saving data");
            setSavingData(false);
        }
        finally{
            setSavingData(false);
        }
    }
  };

  const handleCancel = () => {
    setLabel(serviceLabel);
    setEditMode(false);
  };

  return (
    <FlexRow>
      {editMode ? (
        <input
          type="text"
          value={label}
          style={{ color: '#242424', fontWeight: 700 }}
          onChange={e => setLabel(e.target.value)}
        ></input>
      ) : (
        serviceLabel
      )}

      {/* <ButtonWrapper>
        {editMode ? (
          <>
            <SVGWrapper onClick={handleCancel}>
              <CancelSVG />
            </SVGWrapper>
            <SVGWrapper onClick={handleSave}>
              <SaveSVG color="#ffffff" />
            </SVGWrapper>
          </>
        ) : (
          <>
            <SVGWrapper onClick={() => setEditMode(true)}>
              <EditSVG />
            </SVGWrapper>
          </>
        )}
      </ButtonWrapper> */}
    </FlexRow>
  );
}
